<template>
  <div v-if="visible" class="IntervalIOList">
    <box :title="$t('PeriodicIOList')">
      <div v-if="list.length > 0">
        <IntervalIOListWebinPeriod v-if="hasPeriod" :list="list" class="hidden-sm-and-down" />
        <IntervalIOListWeb v-if="!hasPeriod" :list="list" class="hidden-sm-and-down" />
        <IntervalIOListMob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import EosToastType from "../../../model/EosToastType";
import DateUtils from '../../../utils/DateUtils';
import IntervalIOListMob from "./IntervalIOListMob.vue";
import IntervalIOListWeb from "./IntervalIOListWeb.vue";
import IntervalIOListWebinPeriod from "./IntervalIOListWebinPeriod.vue";

export default {
  components: { IntervalIOListWeb, IntervalIOListMob,IntervalIOListWebinPeriod },
  props: {
    visible: { type: Boolean, default: true },
    beginDate: String,
    endDate: String,
  },
  mounted() {
    this.GetPersonIoInfo();
  },
  data() {
    return {
      list: [],
      hasPeriod:false,
      // startTime:'',
      // EndTime:'',
    };
  },
  methods: {
    GetPersonIoInfo() {
      this.hasPeriod=true;
      var moment = require("jalali-moment");
      var startDate = moment()
        .locale("fa")
        .subtract(2, "days")
        .format("YYYY/M/D");
      var endDate = moment().locale("fa").add(2, "days").format("YYYY/M/D");

      const params = new URLSearchParams();
      params.append("beginDate", DateUtils.fixDateFormatTwoDigit(startDate));
      params.append("endDate", DateUtils.fixDateFormatTwoDigit(endDate));
      var perno = this.$store.state.auth.auth.username;
      params.append("perno", perno);

      this.$store
        .dispatch("GetPersonIoInfo", { params })
        .then((result) => {
          ////console.log(result);
          debugger
          if (result.type === "success") {
            this.list = result.data;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
    GetPersonIoInfForBeiginTime( startTime,EndTime) {
      debugger
    

      const params = new URLSearchParams();
      params.append("beginDate", DateUtils.fixDateFormatTwoDigit(startTime));
      params.append("endDate", DateUtils.fixDateFormatTwoDigit(EndTime));
      var perno = this.$store.state.auth.auth.username;
      params.append("perno", perno);

      this.$store
        .dispatch("GetPersonIoInfoClockDump", { params })
        .then((result) => {
          ////console.log(result);
          debugger
          if (result.type === "success") {
            this.list = result.data;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
    showIntervalDays(intervalDaysNumber, beginDate) {
      
      var moment = require("jalali-moment");

      //console.log(intervalDaysNumber);
      //console.log(beginDate);
      let end=moment(beginDate, 'jYYYY/jMM/jDD')
        .locale("fa")
        .add(2, "days")
        .format("YYYY/M/DD");
        let start=moment(beginDate, 'jYYYY/jMM/jDD')
        .locale("fa")
        .subtract(2, "days")
        .format("YYYY/M/DD");
      //  let start = moment(beginDate, 'jYYYY/jMM/jDD');
      //  start.locale('fa').format('YYYY/MM/DD');
      //  start.add(1, 'day').locale('fa').format('YYYY/MM/DD'); 
      //  .locale("fa").add(2, "days").format("YYYY/M/D");
       //
       console.log(start);
       console.log(end);

      // let end=moment(beginDate,'fa', 'YYYY/MM/DD').subtract(2, "days").locale('fa').format('YYYY/MM/DD');
      // this.GetPersonIoInfo(beginDate, beginDate);
      this.GetPersonIoInfForBeiginTime(start, end);
    },
  },
};
</script>

<style>
</style>